/**
 * @file
 * Theme javascript.
 */

// scroll to hash
function scrollToHash(target) {
  var targetObject;

  if (typeof target == 'object') {
    targetObject = target;
  } else {
    targetObject = jQuery(typeof target == 'string' ? target : window.location.hash)
  }
  var offset = targetObject.offset().top;
  var screenWidth = window.screen.width;
  var isTablet = screenWidth <= 1188 && screenWidth >= 768;
  var headerSize;
  if (jQuery('body').hasClass('toolbar-horizontal')) {
    headerSize = isTablet ? 220 : 160;
  } else {
    headerSize = isTablet ? 130 : 80;
  }
  jQuery('html, body').animate({
    scrollTop: offset - headerSize
  }, {
    duration: 500,
    easing: 'linear'
  });
}

(function ($, once) {
  "use strict";

  // Basic functions to get/set cookies.
  function setCookie(cname, cvalue, exdate) {
    document.cookie = cname + "=" + cvalue + ";expires=" + exdate + ";path=/";
  }

  function getCookie(cname) {
    const name = cname + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');

    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];

      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }

      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }

    return "";
  }

  // loading close desktop and display stuff animated
  Drupal.behaviors.loadingClose = {
    attach: function (context, settings) {
      /*disabled because of #32884
      $(document).ready(function(){
        $(this).scrollTop(0);
      });*/
      $(window).on('load', function () {
        $(".loading", context).addClass('animated fadeOut').hide();
        setTimeout(function () {
          $('.path-home header, .path-frontpage header', context).addClass('animated fadeInDown');
        }, 500);
        setTimeout(function () {
          $('.guide-campus-france', context).addClass('animated fadeInUp');
        }, 1900);
        setTimeout(function () {
          $('div.header .page-title', context).addClass('animated fadeIn');
          $('div.header .media-image .field--name-name', context).addClass('animated fadeIn');
        }, 2400);
        setTimeout(function () {
          $('div.home:not(.slider-brut) div.header picture', context).each(function () {
            $(this).addClass('show-mug')
          });
        }, 3000);
      });
    }
  };
  // Click on header items
  Drupal.behaviors.headerItems = {
    attach: function (context, settings) {
      $('.region-header-tools > div:not(.block-campus-common-liens-utiles) > div.bouton', context).on('click', function () {
        var innerLink = $(this).find('a');
        if (innerLink.length) {
          window.location.href = innerLink[0].href;
        } else {
          $(this).parent().toggleClass('active').siblings().removeClass('active');
          $('.hamburger-icon').removeClass('active');
          $('.block-campus-common-menu-principal').removeClass('active');
          $(this).parent().find('#edit-text, #edit-name').focus();
        }
      });
    }
  };
  // Set overlay globally
  Drupal.behaviors.setOverlay = {
    attach: function (context, settings) {
      $(document).on('click', context, function (e) {
        if ($('header').find('li.active, div.active').length !== 0 || $('.collections > .items').find('.item-open').length !== 0) {
          $('.overlay').addClass('active');
          if ($('.collections > .items').find('.item-open').length == 0) {
            $('html').addClass('noscroll');
          }
        } else {
          $('.overlay').removeClass('active');
          $('html').removeClass('noscroll');
        }
      });
    }
  };
  // Main menu sublevel active states
  Drupal.behaviors.mainMenuActiveStates = {
    attach: function (context, settings) {
      var $selector = $('header .block-campus-common-menu-principal > ul.menu > li > ul > li.menu-item--expanded > span', context);
      $selector.on('click', function () {
        $(this).parent().toggleClass('active').siblings().removeClass('active');
      });
    }
  };
  // menu with images
  Drupal.behaviors.menuWithImages = {
    attach: function (context, settings) {
      // wrap first three items
      var $selector_all = $('header .block-campus-common-menu-principal > ul.menu > li > ul > li > ul', context);
      $selector_all.each(function () {
        $(this).append('<a href="#" class="close">&nbsp;</a>');
      });
      var $selector = $('header .block-campus-common-menu-principal > ul.menu > li > ul > li.with-images > ul', context);
      $selector.each(function () {
        $(this).find('> li:lt(3)').wrapAll('<div class="image-group"></div>');
        $(this).find('> li').wrapAll('<div class="links-group"></div>');
      });
      $(document).on('click', 'header .block-campus-common-menu-principal > ul.menu > li > ul > li > ul a.close', function (e) {
        e.preventDefault();
        $(this).parent().parent().removeClass('active');
      });
      // outside container click
      $(document).bind('mouseup touchend', function (e) {
        var container = $('header .block-campus-common-menu-principal > ul.menu', context);
        if (!container.is(e.target) && container.has(e.target).length === 0) {
          $('header .block-campus-common-menu-principal > ul.menu > li > ul > li', context).removeClass('active');
        }
      });
    }
  };
  // Append close buttons to contenu
  Drupal.behaviors.headerToolsCloseButtons = {
    attach: function (context, settings) {
      $('.region-header-tools .contenu', context).each(function () {
        $(this).append('<a href="#" class="close">&nbsp;</a>');
      });
      $(document).on('click', '.region-header-tools > div:not(.block-campus-common-liens-utiles) > .contenu > a.close', function (e) {
        e.preventDefault();
        $(this).parent().parent().removeClass('active');
      });
      $(document).bind('mouseup touchend', function (e) {
        var container = $('.region-header-tools, .hamburger-icon, .block-campus-common-menu-principal, .collections > .items > .item', context);
        if (!container.is(e.target) && container.has(e.target).length === 0) {
          $('.region-header-tools > div:not(.block-campus-common-liens-utiles)', context).removeClass('active');
          $('.overlay').removeClass('active');
          $('html').removeClass('noscroll');
          $('.hamburger-icon').removeClass('active');
          $('.block-campus-common-menu-principal').removeClass('active');
          $('.collections > .items > .item').removeClass('item-open');
        }
      });
    }
  };
  // Navigation sticky
  Drupal.behaviors.headerNavSticky = {
    attach: function (context, settings) {
      var $header = $('header', context),
        scrollDownClass = 'scroll-down',
        scrollUpClass = 'scroll-up',
        activateAtY = $header.outerHeight(),
        $h1 = $('h1');

      if ($h1.length) {
        $header.find('.region-header-menu').append(
          $('<div class="page-title"></div>').text($h1.first().text())
        );
      }

      function deactivateHeader() {
        if (!$header.hasClass(scrollDownClass)) {
          $header.addClass(scrollDownClass);
        }
      }

      function activateHeader() {
        if ($header.hasClass(scrollDownClass)) {
          $header.removeClass(scrollDownClass);
        }
      }

      var lastScrollTop = 0;
      $(window).scroll(function (event) {
        if ($(window).scrollTop() > activateAtY) {
          deactivateHeader();
        } else {
          activateHeader();
        }
        var st = $(this).scrollTop();
        if (st > lastScrollTop) {
          $header.removeClass(scrollUpClass);
        } else {
          if (typeof Drupal.behaviors.headerNavSticky.preventOnUp == 'undefined') {
            $header.addClass(scrollUpClass);
          }
        }
        lastScrollTop = st;
      });
    }
  };
  // Mobile hamburger
  Drupal.behaviors.mobileHamburger = {
    attach: function (context, settings) {
      $('.hamburger-icon', context).on('click', function () {
        $(this).toggleClass('active');
        $('.region-header-tools > div').removeClass('active');
        $('.language-mobile').removeClass('active');
        $('header .block-campus-common-menu-principal').toggleClass('active');
      });
    }
  };
  // Mobile convert first level nav items to drop down
  Drupal.behaviors.mobileMenuDropdown = {
    attach: function (context, settings) {
      // select option is mobile friendly !
      var $select = $('<select />');
      $select.appendTo('header .block-campus-common-menu-principal');

      $('header .block-campus-common-menu-principal > ul.menu > li > a', context).each(function () {
        var el = $(this);
        var $window_width = $(window).width();
        if (el.attr('class') === 'is-active' && $window_width < 768) {
          el.text(function (i, text) {
            return Drupal.t('Votre profil: ') + text;
          });
        }
        var $option = $('<option />', {
          'value': el.attr('href'),
          'class': el.attr('class'),
          'text': el.text(),
          'data-campus-id': el.attr('data-campus-id')
        });
        if (el.attr('data-campus-id') === getCookie('campusProfil')) {
          $option.attr('selected', 'selected');
        }
        $option.appendTo($select);
      });

      $('header .block-campus-common-menu-principal select', context).change(function () {
        var $selectedOption = $(this).find('option:selected');
        // Trigger click is needed to let menu-principal.js handle it and set the cookie.
        $('header .block-campus-common-menu-principal > ul.menu > li > a[data-campus-id="' + $selectedOption.attr('data-campus-id') + '"]', context).trigger('click');
        // But it does not change the page…
        window.location = $selectedOption.val();
      });
    }
  };
  // Read more body global
  Drupal.behaviors.readMoreBodyText = {
    attach: function (context, settings) {
      $('.node-body-slushy .field--name-field-body', context).each(function () {
        $(this).append('<a href="#" class="readmore-body" data-text="' + Drupal.t('Lire la suite') + '">' + Drupal.t('Lire la suite') + '</a>')
      });
      $(document).delegate('.node-body-slushy .field--name-field-body .readmore-body', 'click', function (e) {
        e.preventDefault();
        $(this).parent().toggleClass('active');
        $(this).remove();
      });
    }
  };
  Drupal.behaviors.localCountryCookie = {
    attach: function (context, settings) {
      // Si on est sur un site local, on vérifie que le cookie est défini.
      $('#block-campuslienverslesiteinternational', context)
        .each(function () {
          if (getCookie('campusPays') != settings.campus.pays) {
            setCookie('campusPays', settings.campus.pays, {
              expires: 365,
              path: '/',
              domain: settings.campus.cookie_domain
            });
          }
        });

      // Si on est sur le site international, si le cookie existe, on filtre la liste
      $('#block-campussitespays', context)
        .each(function () {
          var country = getCookie('campusPays');
          if (country) {
            var jThis = $(this), trigger = jThis.find('.bouton');
            jThis
              .find('.listes-sites a[href*=".' + country + '."]')
              .each(function () {
                if (!isMobile) {
                  var snippet = $('<div />'), close = $('<span />').text(Drupal.t('Close')), link = $('<a />'),
                    label = $(this).text();
                  snippet.addClass('local-displayed');
                  link.text(label);
                  link.attr('href', 'http://' + country + settings.campus.cookie_domain);
                  snippet.append(link);
                  snippet.append(close);
                  trigger.data('default-text', trigger.text());
                  trigger.data('defaut-title', trigger.attr('title'));
                  trigger.empty().append(snippet);
                  trigger.attr('title', label);
                  close.attr('title', Drupal.t('Close'));
                  close.bind('click', function () {
                    setCookie('campusPays', '', {path: '/', domain: settings.campus.cookie_domain});
                    trigger.html(trigger.data('default-text'));
                    trigger.attr('title', trigger.data('default-title'));
                  });
                } else {
                  var clone = jQuery.clone(this), jClone = $(clone);
                  jClone
                    .text(Drupal.t('Back') + ' : ' + jClone.text())
                    .addClass('current-country');
                  $('#block-campussitespays .mention')
                    .prepend(clone);
                }
              });
          }
        });
    }
  }
  // Mobile pseudo continent
  Drupal.behaviors.mobilePseudoContinent = {
    attach: function (context, settings) {
      $('.listes-sites .pseudo-continent .nom', context).on('click', function () {
        //$('.listes-sites .pseudo-continent .nom').parent().removeClass('active');
        $(this).parent().toggleClass('active');
        $(this).parent().find('> .nom', context).prepend('<span>' + Drupal.t('Retour') + '</span>');
        $(this).parent().parent().toggleClass('hide-others');
        $(this).parent().parent().parent().toggleClass('hide-close-button');
      });
      $('.region-header-tools > div.block-campus-common-sites-pays .mention', context).wrapInner('<span></span>');
    }
  };
  // Mobile header (xs): header tools to main nav
  Drupal.behaviors.mobileHeaderToolsNav = {
    attach: function (context, settings) {
      var $clone_lang = $('div.block-campus-common-language > .contenu > ul', context).addClass('mobile-language');
      var $clone_tools = $('div.block-campus-common-liens-utiles > ul', context).addClass('mobile-tools');
      $clone_lang.clone().prependTo('header .block-campus-common-menu-principal');
      $clone_tools.clone().appendTo('header .block-campus-common-menu-principal');
      // mobile language triggers language contenu
      $('.region-header-tools > div.block-campus-common-language > .contenu > ul', context).clone().appendTo('header .block-campus-common-menu-principal').wrap('<div class="language-mobile"></div>');
      $('.language-mobile').prepend('<a href="#" class="language-back"><span>' + Drupal.t('Retour') + '</span> ' + Drupal.t('Langue') + '</a>');
      $('.mobile-language > li > a', context).on('click', function (e) {
        $('.language-mobile').toggleClass('active');
      });
      $('header .block-campus-common-menu-principal > ul[class^="language-switcher-"] > li:first-of-type > a', context).on('click', function (e) {
        var $window_width = $(window).width();
        if ($window_width < 768) {
          e.preventDefault();
        }
      });
      $('.language-back', context).on('click', function (e) {
        e.preventDefault();
        $(this).parent().removeClass('active');
      });
    }
  };
  // Mobile navigation F3 - show/hide
  Drupal.behaviors.mobileMenuShowHide = {
    attach: function (context, settings) {
      $('header .block-campus-common-menu-principal > ul.menu > li > ul > li.menu-item--expanded > span, header .block-campus-common-menu-principal > ul.menu > li > ul > li.menu-item--expanded > a', context).on('click', function (e) {
        e.preventDefault();
        $(this).parent().toggleClass('mobile-active').siblings().removeClass('mobile-active');
      });
    }
  };
  // Init slick slider homepage
  Drupal.behaviors.hpSlickSlider = {
    attach: function (context, settings) {
      $('div.header > .field--name-field-images', context).slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 6000,
        fade: true,
        cssEase: 'linear',
        pauseOnFocus: false,
        pauseOnHover: false
      })

      if ($('html').attr('dir') === 'rtl') {
        $('div.header > .field--name-field-images').slick('slickSetOption', 'rtl', true, true);
      }
    }
  };
  // Media image: legende credit show
  Drupal.behaviors.mediaImageLegendeDisplay = {
    attach: function (context, settings) {
      $('.header .media-image', context).each(function (e) {
        $(this).append('<a href="#" class="show-legende"></a>');
      });
      $('.header .media-image a.show-legende', context).on('click', function (e) {
        e.preventDefault();
        $(this).parent().find('.legende-credit').toggleClass('active');
      });
    }
  };
  // Slick slider on agenda items
  Drupal.behaviors.slickSliderAgenda = {
    attach: function (context, settings) {
      $('.agenda > .items', context).slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false
      });
      $('.dossiers-thematiques > .field--name-field-dossiers', context).slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false
      });

      if ($('html').attr('dir') === 'rtl') {
        $('.dossiers-thematiques > .field--name-field-dossiers, .agenda > .items')
          .slick('slickSetOption', 'rtl', true, true);
      }
    }
  };

  // Guide Campus France
  Drupal.behaviors.guideCampusFrance = {
    attach: function (context, settings) {
      // Toggle items
      var $question = $('.guide-campus-france .question', context);
      $question.on('click', function () {
        $(this).parent().toggleClass('active');
        $(this).next('.reponse').slideToggle();
        $(this).parent().siblings().children().next().slideUp();
        $(this).parent().siblings().children().next().parent().removeClass('active');
        return false;
      });
      $('.guide-campus-france-ajax .form-submit', context).hide();
      if (!isMobile) {
        // Init selectize
        $('.guide-campus-france-ajax.guide-recherche-formation .form-select', context).selectize({
          onInitialize: function () {
            this.$control_input.attr('readonly', true);
          }
        });
        // Change placeholder text
        $('.guide-campus-france-ajax.guide-financer-etudes .form-select', context).selectize({
          onDropdownOpen: function () {
            this.$control_input.attr('placeholder', Drupal.t('Exemple : Vietnam ou Maroc'));
            this.$control_input.css({
              width: '100%'
            });
          },
          onDropdownClose: function () {
            this.$control_input.attr('placeholder', Drupal.t('sélectionner un pays'));
          }
        });
        // Clear selected items from selectize control on dropdown click
        $(document).find('.guide-campus-france-ajax select', context).each(function () {
          var $select = $(this).selectize();
          $('.selectize-control').on('click', function () {
            var selectize = $select[0].selectize;
            selectize.clear(true);
          });
        });
      }
    }
  };

  // init selectize
  Drupal.behaviors.selectizeInit = {
    attach: function (context, settings) {
      $(function () {
        $('.ows-search-views-sort-form select', context).selectize();
        $('.field--name-webform .form-select', context).selectize();
        $('.device-desktop form.user-form select', context).selectize();
        $('.path-mon-campus .facets select', context).selectize();
      });
    }
  };

  // Autoselect sort search.
  Drupal.behaviors.searchAutoselectSort = {
    attach: function (context, settings) {
      $('#ows-search-views-sort-form select', context).on('change', function () {
        $(this).parents('form').submit();
      });
    }
  };
  // auto_promo class parents
  Drupal.behaviors.autoPromoParentsClass = {
    attach: function (context, settings) {
      $('.auto_promo', context).each(function (e) {
        var $get_classes = $(this).attr('class').split(' ');
        $(this).parent().addClass('parent-' + $get_classes[1]);
      });
      // this is needed because we don't need multiple wrappers there (can't be done in theming)
      $('.paragraph--type--contenus-aide .wrapper > div', context).contents().unwrap();
    }
  };
  // paragraph paralax img to bg
  Drupal.behaviors.paralaxImgToBg = {
    attach: function (context, settings) {
      $('.paragraph--type--parallax', context).each(function (e) {
        var $img_src = $(this).find('.field--name-field-visuel-principal img').attr('src');
        $(this).css('background-image', 'url("' + $img_src + '")');
      });
    }
  };
  // animate home
  Drupal.behaviors.animateHomeIcons = {
    attach: function (context, settings) {
      var wh = $(window).height();
      var $o_s = 150;
      var $o_e = 200;
      // icon 1
      var $icon_1 = $('.guide-campus-france', context);
      if ($icon_1.length) {
        var $icon_1_end = $icon_1.offset().top;
        var $icon_1_rnd = Math.floor(Math.random() * $o_s) + $o_e;
        $icon_1.append('<div class="moving-icon icon-eiffel" data-0="top:0px;" data-' + $icon_1_end + '="top:-' + $icon_1_rnd + 'px;"></div>');
      }
      // icon 2
      var $icon_2 = $('.temoignages', context);
      if ($icon_2.length) {
        var $icon_2_start = Math.floor($icon_2.offset().top - wh);
        var $icon_2_end = Math.floor($icon_2.offset().top);
        var $icon_2_rnd = Math.floor(Math.random() * $o_s) + $o_e;
        $icon_2.append('<div class="moving-icon icon-temoignages" data-' + $icon_2_start + '="top:60px;" data-' + $icon_2_end + '="top:-' + $icon_2_rnd + 'px;"></div>');
      }
      // icon 3
      var $icon_3 = $('.push-timeline', context);
      if ($icon_3.length) {
        var $icon_3_start = Math.floor($icon_3.offset().top - wh);
        var $icon_3_end = Math.floor($icon_3.offset().top);
        var $icon_3_rnd = Math.floor(Math.random() * $o_s) + $o_e;
        $icon_3.append('<div class="moving-icon icon-timeline" data-' + $icon_3_start + '="top:0px;" data-' + $icon_3_end + '="top:-' + $icon_3_rnd + 'px;"></div>');
      }
      // icon 4
      var $icon_4 = $('.actualites > .titre', context);
      if ($icon_4.length) {
        var $icon_4_start = Math.floor($icon_4.offset().top - wh);
        var $icon_4_end = Math.floor($icon_4.offset().top);
        var $icon_4_rnd = Math.floor(Math.random() * $o_s) + $o_e;
        $icon_4.append('<div class="moving-icon icon-actualites" data-' + $icon_4_start + '="top:0px;" data-' + $icon_4_end + '="top:-' + $icon_4_rnd + 'px;"></div>');
      }
      // icon 5
      var $icon_5 = $('.agenda > .titre', context);
      if ($icon_5.length) {
        var $icon_5_start = Math.floor($icon_5.offset().top - wh);
        var $icon_5_end = Math.floor($icon_5.offset().top);
        var $icon_5_rnd = Math.floor(Math.random() * $o_s) + $o_e;
        $icon_5.append('<div class="moving-icon icon-agenda" data-' + $icon_5_start + '="top:0px;" data-' + $icon_5_end + '="top:-' + $icon_5_rnd + 'px;"></div>');
      }
      // icon 6
      var $icon_6 = $('.outils > .titre', context);
      if ($icon_6.length) {
        var $icon_6_start = Math.floor($icon_6.offset().top - wh);
        var $icon_6_end = Math.floor($icon_6.offset().top);
        var $icon_6_rnd = Math.floor(Math.random() * $o_s) + $o_e;
        $icon_6.append('<div class="moving-icon icon-outils" data-' + $icon_6_start + '="top:0px;" data-' + $icon_6_end + '="top:-' + $icon_6_rnd + 'px;"></div>');
      }
      // icon 7
      var $icon_7 = $('.field--name-field-partenaires', context);
      if ($icon_7.length) {
        var $icon_7_start = Math.floor($icon_7.offset().top - wh);
        var $icon_7_end = Math.floor($icon_7.offset().top);
        var $icon_7_rnd = Math.floor(Math.random() * $o_s) + $o_e;
        $icon_7.append('<div class="moving-icon icon-partners" data-' + $icon_7_start + '="top:20px;" data-' + $icon_7_end + '="top:-' + $icon_7_rnd + 'px;"></div>');
      }
      // desktop only
      if (!isMobile) {
        var s = skrollr.init();
      }
      // fade in blocks
      if (isMobile != true) {
        $(window).scroll(function () {
          /* Animate element when becomes visible on viewport */
          $('.home > div:not(.header):not(.france):not(.guide-campus-france):not(.agenda-institutionnel-wrapper) > *:in-viewport', context).addClass('animated fadeIn');
          // other animations: france
          $('.guide-campus-france', context).waypoint({
            handler: function (direction) {
              $(once('carte-france', $('.carte-france'), context)).addClass('animated fadeInLeft');

              setTimeout(function () {
                $(once('bienvenue-france', $('.bienvenue-france'), context)).addClass('animated fadeInRight');
              }, 200);

              setTimeout(function () {
                $(once('pourquoi-choisir-france', $('.pourquoi-choisir-france'), context)).addClass('animated fadeInUp');
              }, 350);
            },
            offset: Math.floor($(window).height() / 2)
          });
        });
      }
    }
  };

  // go to top
  Drupal.behaviors.goToTop = {
    attach: function (context, settings) {
      $('a[href="#top"]').on('click', function (e) {
        $('html, body', context).animate({scrollTop: 0}, 'slow');
        return false;
      });
      $(window).scroll(function () {
        if ($(this).scrollTop()) {
          $('.gototop:hidden', context).stop(true, true).fadeIn();
        } else {
          $('.gototop', context).stop(true, true).fadeOut();
        }
      });
    }
  };
  // animate text background
  Drupal.behaviors.animateTextBackgrounds = {
    attach: function (context, settings) {
      $('.fixe > span', context).waypoint({
        handler: function (direction) {
          $(this.element).addClass('animatebg');
        },
        offset: Math.floor($(window).height() / 2)
      });
      $('.variable > span', context).waypoint({
        handler: function (direction) {
          $(this.element).addClass('animatebg');
        },
        offset: Math.floor($(window).height() / 2)
      });
    }
  };
  // event slick
  Drupal.behaviors.eventSlick = {
    attach: function (context, settings) {
      $('ul.diaporama', context).slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false
      });

      if ($('html').attr('dir') === 'rtl') {
        $('ul.diaporama').slick('slickSetOption', 'rtl', true, true);
      }
    }
  };
  // image lightbox
  Drupal.behaviors.imgLightBox = {
    attach: function (context, settings) {
      $('.en-images', context).append('<div class="my-gallery"></div>');
      $('.en-images > div.item-list ul li', context).each(function () {
        var $img_find = $(this).find('article');
        var $img_src = $img_find.data('full-image-url');
        $img_find.attr('itemprop', 'thumbnail');
        $(this).find('img').wrap('<a href="' + $img_src + '"></a>');
        $(this).find('a').appendTo(".my-gallery");
      });
      $('.my-gallery', context).wrap('<div class="my-gallery-wrapper"></div>');
      $('.en-images .see-more', context).appendTo('.my-gallery > a:nth-of-type(5)');
      $('.my-gallery', context).lightGallery({
        thumbnail: true,
        share: false,
        animateThumb: false,
        showThumbByDefault: true,
        addClass: 'showThumbByDefault'
      });
    }
  };
  // social wall see more
  Drupal.behaviors.socialWallSeeMore = {
    attach: function (context, settings) {
      // generate modale
      $('.modale-social-wall', context).append('<div class="container-modale"><a href="#" class="close-social-modale"></a><h2>Social wall</h2><div class="modal-wall-list"></div></div>');
      // clone content to modale
      var a = $('.social-wall > .item-list', context).html();
      var b = $('.modale-social-wall .modal-wall-list', context).html(a);
      // trigger on click
      $('.social-wall > .see-more', context).on('click', function (e) {
        e.preventDefault();
        $('.modale-social-wall', context).addClass('active');
        $('html', context).addClass('noscroll');
        /*$('.modale-social-wall iframe', context).each(function() {
          this.contentWindow.location.reload(true);
        });*/
      });
      // close social modale
      $(document).on('click', 'a.close-social-modale', function (e) {
        e.preventDefault();
        $(this).parent().parent().removeClass('active');
        $('html', context).removeClass('noscroll');
      });
      // add load more button to modale
      $('.modale-social-wall .container-modale', context).append('<div class="modal-action"><a href="#" class="loadmore">' + Drupal.t('Charger plus de publications') + '</a></div>');
      // load more stuff
      var $n_items = 6; // you need to hide in css more than nr. of items defined there
      var $n_items_half = $n_items / 2;
      var $n_len = $('.modale-social-wall ul li', context).length;
      if ($n_len > $n_items) {
        $('.modale-social-wall .loadmore', context).show();
      }
      $('.modale-social-wall ul li', context).slice(0, $n_items).show();
      var $cur_length = $('.modale-social-wall ul li', context).length;
      if ($cur_length <= 6) {
        $('.modale-social-wall .loadmore', context).hide();
      }
      $('.modal-action a.loadmore', context).on('click', function (e) {
        e.preventDefault();
        $('.modale-social-wall ul li:hidden', context).slice(0, $n_items_half).fadeIn();
        if ($('.modale-social-wall ul li:hidden', context).length == 0) {
          $('.modale-social-wall .loadmore', context).fadeOut('slow');
        }
      });
    }
  };
  // agenda-institutionnel to parent class
  Drupal.behaviors.agendaInstitutionnelWrap = {
    attach: function (context, settings) {
      $('div.agenda-institutionnel', context).parent().addClass('agenda-institutionnel-wrapper');
      // wrap to span evenement
      $('div.agenda.agenda-institutionnel #agenda .right > article .top > div:nth-of-type(1)').each(function (e) {
        $(this).wrapInner('<span></span>');
      });
    }
  };
  // Multiple related search facets.
  Drupal.behaviors.searchMultipleFacets = {
    attach: function (context, settings) {
      const facetCategorie = $('.block-facet-blockcategorie-espace-doc', context);
      if (!facetCategorie.hasClass('facet-active')) {
        return;
      }

      const facetThematique = $('.block-facet-blockcategorie-espace-doc-level2', context);
      const facetSousCategorie = $('.block-facet-blockcategorie-espace-doc-level3', context);

      if (facetThematique.hasClass('facet-active')) {
        facetCategorie.find('.facets-widget-links a.is-active').on('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
        });
      }

      if (facetSousCategorie.hasClass('facet-active')) {
        facetThematique.find('.facets-widget-links a.is-active').on('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
        });
      }
    }
  };
  // mobile filters
  Drupal.behaviors.mobileSearchFilter = {
    attach: function (context, settings) {
      $('.path-recherche .sidebar-main-container .layout-sidebar > div, .path-faq .sidebar-main-container .layout-sidebar > div, .path-agenda .sidebar-main-container .layout-sidebar > div', context).prepend('<div class="mobile-search"><p>' + Drupal.t('Affiner') + '</p> <a href="#" class="mobile-search-close"></a></div>');
      $('.path-recherche .sidebar-main-container .layout-sidebar > div > div > h2, .path-faq .sidebar-main-container .layout-sidebar > div > div > h2,  .path-agenda .sidebar-main-container .layout-sidebar > div > div > h2', context).each(function (e) {
        $(this).on('click', function () {
          $(this).parent().find('> ul').toggleClass('active');
          $(this).toggleClass('active');
        });
      });
      var $sidebar_container = $('.path-agenda .sidebar-main-container .layout-sidebar, .path-recherche .sidebar-main-container .layout-sidebar, .path-faq .sidebar-main-container .layout-sidebar', context);
      $('.path-agenda .region-help, .path-recherche .region-help, .path-faq .region-help', context).prepend('<div class="mobile-filter-buttons"><ul><li><a href="#" class="open-filter">' + Drupal.t('Affiner') + ' <span id="facetnum">(0)</span></a></li><li><a href="#" class="open-trier">' + Drupal.t('Trier par') + '</a></li></ul></div>');
      // open filter
      $('a.open-filter', context).on('click', function (e) {
        e.preventDefault();
        $sidebar_container.addClass('active');
        $('html', context).addClass('noscroll');
      });
      /* generate mobile trier
      @todo -> link needs to be set on click
      */
      $('.path-agenda .region-help, .path-recherche .region-help, .path-faq .region-help', context).append('<div class="mobile-trier-par"><div class="heading"><p>' + Drupal.t('Trier par') + '</p><a href="#" class="close-trierpar"></a></div><ul class="trier-values"></ul></div>');
      $('.ows-search-views-sort-form option', context).each(function (e) {
        var $text_val = $(this).text();
        $('ul.trier-values', context).append('<li><a href="?sort_by=' + $(this).val() + '">' + $text_val + '</a></li>');
      });
      // open trier
      $('a.open-trier', context).on('click', function (e) {
        e.preventDefault();
        $('.mobile-trier-par', context).addClass('active');
        $('html', context).addClass('noscroll');
      });
      // apend facet count
      var $facet_count = $('.block-facets > ul li a.is-active', context).length;
      $('#facetnum', context).text('(' + $facet_count + ')');

      // close filter
      $('a.mobile-search-close', context).on('click', function (e) {
        e.preventDefault();
        $sidebar_container.removeClass('active');
        $('html', context).removeClass('noscroll');
      });
      // close trier par
      $('a.close-trierpar', context).on('click', function (e) {
        e.preventDefault();
        $('.mobile-trier-par', context).removeClass('active');
        $('html', context).removeClass('noscroll');
      });
    }
  };
  // agenda-institutionnel to parent class
  Drupal.behaviors.dossierBgImg = {
    attach: function (context, settings) {
      var $bg_img = $('.page-node-type-dossier .header .bg-image', context).attr('style');
      // set the bg
      $('.page-node-type-dossier .header', context).attr('style', $bg_img);
    }
  };
  // dossiers tab
  Drupal.behaviors.dossierTabs = {
    attach: function (context, settings) {
      // add active class on first type
      $('.tab-content', context).eq(0).addClass('active');
      $('.contenus-editoriaux .item-list ul li', context).eq(0).addClass('active');
      // tab displaying
      $('.contenus-editoriaux .item-list ul li', context).each(function (e) {
        $(this).on('click', function (e) {
          var $data_target = $(this).data('target');
          $('.tab-content').removeClass('active');
          $('.tab-content.' + $data_target).addClass('active');
          $('.contenus-editoriaux .item-list ul li').removeClass('active');
          $(this).addClass('active');
        });
      });
    }
  };
  // accordion
  Drupal.behaviors.sidebarAccordeon = {
    attach: function (context, settings) {
      $('.field--name-field-body dl dt > span', context).each(function () {
        var $get_class = $(this).attr('class');
        $(this).parent().addClass($get_class);
      });
      // accordion
      var $accordion = $('.field--name-field-body dl', context);
      $accordion.first().addClass('open');
      $accordion.first().find('dd').slideToggle(300);
      $accordion.on('click touch', function (e) {
        // $accordion.removeClass('open');
        $(this).toggleClass('open');
        $(this).find('dd').slideToggle(300);
      });
    }
  };
  // show map button on carte
  Drupal.behaviors.showMapButtonCarte = {
    attach: function (context, settings) {
      $('.carte-de-france > .header', context).append('<a class="show-carte-map" href="#"></a>');
      $('a.show-carte-map').on('click touch', function (e) {
        e.preventDefault();
        // scroll here
        var $container = $('html, body', context);
        var $header_height = $('header', context).height();
        var $scrollTo = $('.path-carte-de-france .carte-france', context);
        var $scrollToRegions = $('.path-carte-de-france .regions', context);

        var $window_width = $(window).width();
        if ($window_width >= 768) {
          $container.animate({
            scrollTop: $scrollTo.offset().top - $container.offset().top + $container.scrollTop(),
            scrollLeft: 0
          }, 1000);
        } else {
          $container.animate({scrollTop: $scrollToRegions.offset().top - $header_height, scrollLeft: 0}, 1000);
        }
      });
      $('.carte-de-france > div.header > .regions .vocabulary-region .close', context).on('click touch', function (e) {
        $(this).parent().fadeOut(350);
      });
    }
  };
  // Search results: ville header wrap
  Drupal.behaviors.searchResVilleWrap = {
    attach: function (context, settings) {
      $('.block-campus-search-ville', context).wrapInner('<div class="container"></div>');
      $('button.show-map', context).on('click touch', function (e) {
        e.preventDefault();
        //$('html, body').scrollTo('.sidebar-main-container');
        var aTag = $('.region-help', context);
        $('html, body').animate({scrollTop: aTag.offset().top}, 'slow');
      });
    }
  };
  // Vos documents: show more
  Drupal.behaviors.vosDocsMore = {
    attach: function (context, settings) {
      var $size_li = $('ul.documents li', context).length;
      var $x = 3;
      $('ul.documents li:lt(' + $x + ')', context).addClass('active');
      $('.vos-documents .see-more', context).on('click touch', function (e) {
        $x = ($x + 3 <= $size_li) ? $x + 3 : $size_li;
        $('ul.documents li:lt(' + $x + ')').addClass('active');
        if ($x == $size_li) {
          $(this).hide();
        }
      });
    }
  };
  // Vos actus show more
  Drupal.behaviors.vosActusMore = {
    attach: function (context, settings) {
      $('.contenus-recommandes', context).each(function () {
        var $size_li = $(this).find('.wrapper > article').length;
        var $x = 4;
        var $btn_more = $(this).find('.see-more');
        if ($size_li <= 4) {
          $btn_more.hide();
        }
        $btn_more.on('click touch', function (e) {
          $x = ($x + 3 <= $size_li) ? $x + 3 : $size_li;
          $(this).parent().find('article:hidden:lt(' + $x + ')').show();
          if ($x == $size_li) {
            $(this).hide();
          }
        });
      });
    }
  };
  // Append mobile info on trigger button on webform
  Drupal.behaviors.fileInputImgThumb = {
    attach: function (context, settings) {
      var $item = $('.field--name-webform .form-item .description', context);
      $item.each(function () {
        $(this).parent().append('<a href="#" class="show-mobile-desc">i</a>');
      });
      $('a.show-mobile-desc', context).on('click touch', function (e) {
        e.preventDefault();
        $('a.show-mobile-desc').removeClass('active');
        $(this).addClass('active');
        $('.description', context).removeClass('active');
        $(this).parent().find('.description').addClass('active');
      });
    }
  };

  // Check if toolbar exists
  Drupal.behaviors.checkIfToolbar = {
    attach: function (context, settings) {
      var $toolbar = $('#toolbar-administration', context);
      if ($toolbar.length) {
        $('body').addClass('toolbar-active');
      }
    }
  };
  // Validate webforms with jquery.validation
  Drupal.behaviors.validateWebForm = {
    attach: function (context, settings) {
      // add default validation with offset (error messages comes from data['webform-required-error'] attribute)
      $('.field--type-webform form, form.contact-message-feedback-form', context).validate({
        focusInvalid: false,
        invalidHandler: function (form, validator) {
          if (!validator.numberOfInvalids())
            return;
          $('html, body', context).animate({
            scrollTop: $(validator.errorList[0].element).offset().top - 240
          }, 1000);
        }
      });
      // outside container click
      $(document).bind('mouseup touchend', function (e) {
        var container = $('a.show-mobile-desc', context);
        if (!container.is(e.target) && container.has(e.target).length === 0) {
          $('a.show-mobile-desc', context).removeClass('active');
          $('.description.active', context).removeClass('active');
        }
      });
    }
  };
  // Check if evenement has statut div
  Drupal.behaviors.checkEvenementStatut = {
    attach: function (context, settings) {
      var $check = $('.node--type-evenement.node--view-mode-search-result .top > div:nth-of-type(1)', context);
      $check.each(function () {
        if (!$(this).next().hasClass('statut')) {
          $(this).addClass('no-statut');
        }
      });
    }
  };
  // Check if evenement has statut div
  Drupal.behaviors.avatarCheckLabel = {
    attach: function (context, settings) {
      var $avatars = $('.view-avatars input[type="checkbox"]', context);
      $avatars.each(function () {
        $(this).change(function () {
          if ($(this).is(":checked")) {
            $(this).parent().find('label').addClass('is-selected');
          } else {
            $(this).parent().find('label').removeClass('is-selected');
          }
        });
      });
    }
  };
  // Click on avatar submit form
  Drupal.behaviors.clickAvatarSubmit = {
    attach: function (context, settings) {
      $('#entity-browser-avatar-form .view-avatars input[type="checkbox"]', context).on('change', function () {
        $(this).parents('form').find('#edit-submit').trigger('click');
      });
    }
  };
  // Wrap all tables into resposnive container
  Drupal.behaviors.makeResponsiveTables = {
    attach: function (context, settings) {
      $('.content table', context).each(function () {
        $(this).wrap('<div class="table-responsive"></div>');
      });
    }
  };
  // Scroll to hashtags with offset of fixed navigation
  Drupal.behaviors.hashTagScroll = {
    attach: function (context) {
      if (window.location.hash) {
        window.scrollTo(0, 0);
        scrollToHash();
      }
      $(window).on('hashchange', scrollToHash);
      // detect content link click if anchor and add custom scroll
      $('body', context).on('click', '.content a', function (e) {
        if (/#/.test(this.href)) {
          if ($(this).is('[href^="#"]')) {
            e.preventDefault();
            var $url = $(this).attr('href');
            var $hash = $url.substring($url.indexOf('#'));
            scrollToHash($hash);
            window.location.hash = $hash;
          }
        }
      });
    }
  };
  Drupal.behaviors.externalLinks = {
    attach: function (context, settings) {
      $('a[rel*=external]', context).on('click', function (e) {
        if (this.href != '#') {
          window.open(this.href);
        }
        return false;
      });
    }
  };
  // trigger animations on homepage, when user reloads page
  Drupal.behaviors.detectScrollPosOnRefresh = {
    attach: function (context, settings) {
      var $scrollPos = $(window).scrollTop();
      if ($scrollPos > 0) {
        if ($('body').hasClass('path-frontpage') || $('body').hasClass('path-home')) {
          $(document).scrollTop($(window).scrollTop() + 1);
        }
      }
    }
  };
  Drupal.behaviors.searchRemoveClass = {
    attach: function (context, settings) {
      // Évite d'avoir la scrollbar de <main> quand il n'y a pas de résultat.
      if ($('.path-geolocalisation .layout-sidebar-right', context).length === 0) {
        $('.path-geolocalisation .sidebar-main-container', context).removeAttr('class');
      }
    }
  };
  Drupal.behaviors.googleMapOneMarker = {
    attach: function (context, settings) {
      if (typeof OwsGoogleMaps == "undefined") {
        return;
      }
      const oldSetupMarker = OwsGoogleMaps.setupMarker;

      // Surcharge de cette fonction.
      // Si qu'un seul marqueur, on affiche directement la modale/infobulle sans
      // sa croix de fermeture.
      OwsGoogleMaps.setupMarker = function (map, id, datum) {
        var marker = oldSetupMarker(map, id, datum);

        if (map.markersData.length === 1) {
          google.maps.event.trigger(marker, "click");

          // Suppression du onclick du marqueur.
          google.maps.event.clearListeners(marker, "click");
        }
      };
    }
  };

  // collections items display
  Drupal.behaviors.collectionsItemsDisplay = {
    attach: function (context, settings) {
      var $more = $('.more-sous-collection', context);
      $more.on('click touch', function (e) {
        event.preventDefault();
        $(this).parent().find('.sous-collection.element-invisible').removeClass('element-invisible');
        $(this).hide();
      });
    }
  };

  // More favoris.
  Drupal.behaviors.favoris = {
    attach: function (context, settings) {
      var type = ['ressource-documentaire', 'article', 'dossier'];
      type.forEach(function (item) {
        $('.wrapper-' + item + ' .' + item + ' li').each(function (index) {
          var addClass = '';
          if ((index > 6 && (item == 'ressource-documentaire' || item == 'dossier')) || (index > 3 && item == 'article')) {
            addClass = ' element-invisible';
          }
          $(this).addClass('item' + addClass);
        });
        $('.more-favoris.' + item).on('click touch', function (e) {
          var nb_element_invisible = $('.wrapper-' + item + ' .' + item + ' > .element-invisible').length;
          console.log(nb_element_invisible);
          if ((nb_element_invisible < 7 && (item == 'ressource-documentaire' || item == 'dossier')) || (nb_element_invisible < 4 && item == 'article')) {
            $(this).hide();
          }
          if (nb_element_invisible != 0) {
            $('.loading-favoris-' + item).show();
          }
          setTimeout(function () {
            $('.wrapper-' + item + ' .' + item + '  > .element-invisible').each(function (index) {
              if ((index < 7 && (item == 'ressource-documentaire' || item == 'dossier')) || (index < 4 && item == 'article')) {
                $(this).removeClass('element-invisible');
              }
            });
            $('.loading-favoris-' + item).hide();
          }, 500);
        });
      });
    }
  };

  // False favoris.
  Drupal.behaviors.falseFavoris = {
    attach: function (context, settings) {
      var $link = $('.flag-no-authenticated', context);
      $link.on('click touch', function (e) {
        e.preventDefault();
        $('html, body').animate({
          scrollTop: $('body').offset().top
        }, 1000);
        $('.connexion').trigger('click');
      });
    }
  };

  Drupal.behaviors.hoverDefaultVisual = {
    attach: function (context, settings) {
      var $more = $('.visuel img:not(.hover)', context);
      $more.on('mouseover touch', function (e) {
        event.preventDefault();
        $('.visuel .hover').show();
      });

      var $more_leave = $('.visuel .hover', context);
      $more_leave.on('mouseleave', function (e) {
        event.preventDefault();
        $('.visuel .hover').hide();
      });
    }
  };

  Drupal.behaviors.calcDynamicHeight = {
    attach: function (context, settings) {
      $('.node--view-mode-ressource-avec-liens .group-content').each(function (index) {
        var hauteur = $(this).outerHeight();
        $(this).next().css('min-height', hauteur + 'px');
      });
      $('.node--view-mode-search-result-geoloc .group-content').each(function (index) {
        var hauteur = $(this).outerHeight();
        $(this).find('.group-hover').css('min-height', hauteur + 'px');
      });
    }
  };

  Drupal.behaviors.documentsSlider = {
    attach: function (context, settings) {
      var isMobile = $(window).width() < 769 ? true : false;
      var slider = $('.bloc-nouveaute .documents', context);

      if (isMobile) {
        slider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          adaptiveHeight: true,
          fade: true,
        });
      }

      $('.bloc-nouveaute .documents .arrow-prev').on('click', function () {
        slider.slick('slickPrev');
      });

      $('.bloc-nouveaute .documents .arrow-next').on('click', function () {
        slider.slick('slickNext');
      });
    }
  };


  Drupal.behaviors.calculateWidh = {
    attach: function (context, settings) {
      $(window).on('resize load orientationchange', function () {
        let isMobile = $(window).width() < 769 ? true : false;
        let $ressources = $('.node--view-mode-search-result-geoloc .top.ressources', context);
        let $contentRessource = $('#block-campus-content .node__content', context);
        if (isMobile) {
          let largeur = $contentRessource.outerWidth();
          $ressources.css('width', largeur + 'px');
        } else {
          $ressources.removeAttr('style');
        }
      });
    }
  };

  Drupal.behaviors.flagMessage = {
    attach: function (context, settings) {
      $('.flag-favoris').on('click', function () {
        $(this).find('.js-flag-message').remove();
      });
    }
  };

  Drupal.behaviors.facebookTrackLeads = {
    attach: function (context, settings) {
      // Remonte comme lead les clics vers les sites externes
      // ciblés. On ignore le protocole.
      var targets = [
        '://cataloguelm.campusfrance.org/licence/#/catalog',
        '://cataloguelm.campusfrance.org/master/#/catalog',
        '://eacea.ec.europa.eu/node/661_fr',
        '://ec.europa.eu/programmes/erasmus-plus/opportunities-for-individuals/students/erasmus-mundus-joint-master-degrees_en',
        '://doctorat.campusfrance.org/phd/dschools/main',
        '://taughtie.campusfrance.org/tiesearch/#/catalog',
        '://ecolesdete.campusfrance.org/#/main',
      ];
      $(document).on('click', function (e) {
        // S'il s'agit d'un clic sur un lien et que le SDK Facebook est
        // chargé...
        if (e.target.nodeName == 'A' && typeof window.fbq !== undefined) {
          // alors on vérifie si la cible du lien correspond à l'une de
          // nos cibles.
          targets.forEach(function (item) {
            if (e.target.href.indexOf(item) > 0) {
              fbq('track', 'Lead');
            }
          });
        }
      });

      // Remontée des soumissions de l'inscription à la newsletter.
      $('form.campus-newsletter-inscription').on('submit', function () {
        if (typeof window.fbq !== undefined) {
          fbq('track', 'Lead');
        }
      });

      // Remontée des soumissions du formulaire de contact.
      $('form.webform-submission-form').on('submit', function () {
        if (typeof window.fbq !== undefined) {
          fbq('track', 'Lead');
        }
      });
    }
  }

  Drupal.behaviors.foldableParagphs = {
    attach: function (context, settings) {
      $('summary', context)
        .on('click', function () {
          let thisDetail = $(this).parent(), container = thisDetail.closest('.field__items');
          container
            .find('details[open]')
            .not(thisDetail)
            .removeAttr('open');

          Drupal.behaviors.headerNavSticky.preventOnUp = true;
          scrollToHash(thisDetail);
          window.setTimeout(function () {
            delete Drupal.behaviors.headerNavSticky['preventOnUp'];
          }, 2000);
        });
    }
  }

  Drupal.behaviors.tooltip = {
    attach: function (context, settings) {
      $('.wrapper-tooltip', context).each(function () {
        $(this).append('<div class="tooltip">' + $(this).data('tooltip') + '</div>');
        $(this).find('a').attr('target','_blank');
      });
    }
  }

  Drupal.behaviors.homeSlider = {
    attach: function (context, settings) {
      var slider = $('.wrapper-carousel .wrapper-list-visual ul.wrapper', context);

      slider.on('init', function () {
        $('.wrapper-list-label li').eq(0).addClass('active');
      });

      slider.slick({
        arrows: false,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        fade: true,
        autoplay: true,
        autoplaySpeed: 16000,
      });

      var time = 16;
      var tick,
        percentTime;

      function startProgressbar() {
        resetProgressbar();
        percentTime = 0;
        tick = setInterval(interval, 1);
      }

      function interval() {
        percentTime += 1 / (time + 0.1);

        $('.wrapper-carousel .active .progress-bar').css({
          width: percentTime + "%"
        });

        if (percentTime >= 100) {
          slider.slick('slickNext');
          startProgressbar();
        }
      }

      function resetProgressbar() {
        $('.wrapper-carousel .active .progress-bar').css({
          width: 0 + '%'
        });

        clearTimeout(tick);
      }

      startProgressbar();

      slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        resetProgressbar();
        startProgressbar();

        $('.wrapper-list-label li').removeClass('active');
        $('.wrapper-list-label li').eq(nextSlide).addClass('active');

        $('.wrapper-carousel .active .progress-bar').css({
          width: 100 + "%"
        });
      });

      $('.wrapper-list-label .lien:not(.slide-to)').on('click', function (e) {
        e.preventDefault();

        var index = $(this).parent().index();

        slider.slick('slickGoTo', index);
      });

      $('.lien.slide-to', context).on('click', function (e) {
        e.preventDefault();

        var position = 0;

        if ($('#guide-campus').length) {
          position = $('#guide-campus').offset().top;
        }
        else {
          position = $('.header').next('div').find('h2').offset().top;
        }

        var headerHeight = 105;
        var offset = position - headerHeight;

        if ($('body').hasClass('toolbar-fixed')) {
          offset = offset - 39;

          if ($('body').hasClass('toolbar-tray-open toolbar-horizontal')) {
            offset = offset - 40;
          }
        }

        $('html, body').animate({
          scrollTop: offset
        }, 1000);
      });
    }
  }

  Drupal.behaviors.anonymousLoginOpen = {
    attach: function (context, settings) {
      let loginBlock = $('.page-403 #block-campusconnexionoumoncompte');
      if (loginBlock.length > 0) {
        loginBlock.addClass('active');
      }
    }
  }

  Drupal.behaviors.popin = {
    attach: function (context, settings) {
      const popin = $('.field--name-field-popin', context);
      const close = $('.popin .close-button', context);

      if (!popin.length) {
        return false;
      }

      close.on('click', function() {
        const hash = $(this).parents('.field--name-field-popin').find('[data-hash]').attr('data-hash');
        const name = 'popin-' + hash;
        const expire = new Date(new Date().setFullYear(new Date().getFullYear() + 1)); // 1 year

        setCookie(name, hash, expire);

        $(this).parents('.field--name-field-popin').hide();
      });

      popin.each(function() {
        const hash = $(this).find('[data-hash]').attr('data-hash');
        const name = 'popin-' + hash;

        if (!getCookie(name)) {
          $(this).addClass('show');
        }
      });
    }
  }

})(jQuery, once);
